import React from "react";
import { FormattedMessage } from "react-intl";
import Modal from "theme/components/organisms/Modal";
import CookiePage from "theme/modules/Cookie/CookiePage";

const CookieModal = ({
  setAllAuthorizations,
  allCookiesAreConfigured,
  isOpen,
  services,
  cookie,
  consentCookie,
  updateAuthorizations,
  updateConsentAuthorizations,
  finalizeConfiguration,
  onRequestClose,
}) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    appearance="full"
    title={
      <FormattedMessage
        id="modules.Cookie.CookiePage.title"
        defaultMessage="Managing your preferences on cookies"
      />
    }
  >
    <CookiePage
      services={services}
      cookie={cookie}
      consentCookie={consentCookie}
      updateAuthorizations={updateAuthorizations}
      updateConsentAuthorizations={updateConsentAuthorizations}
      setAllAuthorizations={setAllAuthorizations}
      allCookiesAreConfigured={allCookiesAreConfigured}
      finalizeConfiguration={finalizeConfiguration}
    />
  </Modal>
);

export default CookieModal;
